(() => {
  const bar = document.querySelector('[data-article-progress]');
  if (!bar) return;

  const update = () => {
    const doc = document.documentElement;
    const scrollTop = doc.scrollTop || document.body.scrollTop;
    const scrollHeight = doc.scrollHeight || document.body.scrollHeight;
    const clientHeight = doc.clientHeight || window.innerHeight;

    const max = Math.max(scrollHeight - clientHeight, 1);
    const pct = Math.min(Math.max(scrollTop / max, 0), 1);
    bar.style.transform = `scaleX(${pct})`;
  };

  update();
  window.addEventListener('scroll', update, { passive: true });
  window.addEventListener('resize', update);
})();
